import React from "react";

const EmailConfirmed = () => {
  return (
    <div style={{ maxWidth: "400px", margin: "0 auto" }}>
      <h2>Email Confirmed</h2>
      <p>Your email has been successfully confirmed. You can now log in to your account.</p>
    </div>
  );
};

export default EmailConfirmed;